<script lang="ts">
    import {deleteQueryStringParameter, deleteSearchQueryStringParameter, setQueryStringParameter} from "../../url";

    export let selectedStation: string;

</script>

<li class="mb-1">
  <div class="pb-2">
    <label for="floatingInputStation">Station Search</label>
    <i class="bi bi-question-circle-fill" data-bs-toggle="tooltip" data-bs-placement="right"
       title="Tooltip for Station Search with placement on the right"></i>
  </div>
  <!-- station search input w/ floating label -->
  <div>
    <select class="form-select me-1" id="floatingInputStation"
            value={selectedStation}
            on:change={event => { event.target.value !== '' ? setQueryStringParameter('station', event.target.value) : deleteSearchQueryStringParameter('station')}}>
      <option selected value=""></option>
      <option value="USC00010008">USC00010008</option>
      <option value="USC00010063">USC00010063</option>
    </select>
  </div>
</li>